import { globalCss, mediaQueryMap } from "@leagueplatform/genesis-core";

export const careDocumentsModalOverrides = globalCss({
  'p:has(> label[for="file-upload"]) > button': {
    color: "$onSurfaceTextPrimary",
    fontWeight: "bold",
  },
  ".GDS-modal:has(.GDS-modal-content form img) .GDS-modal-close-button": {
    color: "$onSurfaceTextSubdued",
  },
  ".GDS-modal:has(.GDS-modal-content form img) .GDS-modal-close-button-wrapper":
    {
      display: "none",
    },
  ".GDS-modal-content div:has(> img) > .GDS-button:has(.GDS-icon)": {
    color: "$onSurfaceTextCritical",
  },
  [`@media ${mediaQueryMap.mobile}`]: {
    ".GDS-modal:has(.GDS-modal-content form img) .GDS-modal-close-button-wrapper":
      {
        display: "flex",
      },
    ".GDS-modal-content div:has(> img) > .GDS-button:has(.GDS-icon)": {
      color: "$interactiveActionPrimary",
    },
  },
});
